module.exports = __webpack_public_path__ + "static/day15-3d61801476f583f5beadf585fca3973b.png";